/**
 * ISO 3166-1 alpha-2 → FIFA tri-code map for the compact knockout bracket box, which shows a
 * three-letter team label under each crest (e.g. GER, BRA, NED). The feed only carries alpha-2
 * country codes + full names, and alpha-2 ("nl") ≠ the FIFA tri-code ("NED"), so we map the
 * nations that can appear in a World Cup knockout bracket. Unknown codes fall back to a
 * name-derived abbreviation in `toTeamAbbrev`.
 *
 * Keyed by lowercase alpha-2 (the same code the flag CDN uses). The home-nations use the
 * `gb-eng` / `gb-sct` / `gb-wls` / `gb-nir` subdivision codes when the feed sends them, with a
 * plain `gb` fallback.
 */
export const COUNTRY_TRI_CODE: Record<string, string> = {
  // UEFA
  al: 'ALB',
  at: 'AUT',
  be: 'BEL',
  ba: 'BIH',
  bg: 'BUL',
  hr: 'CRO',
  cz: 'CZE',
  dk: 'DEN',
  'gb-eng': 'ENG',
  gb: 'ENG',
  fr: 'FRA',
  de: 'GER',
  gr: 'GRE',
  hu: 'HUN',
  is: 'ISL',
  it: 'ITA',
  nl: 'NED',
  'gb-nir': 'NIR',
  mk: 'MKD',
  no: 'NOR',
  pl: 'POL',
  pt: 'POR',
  ie: 'IRL',
  ro: 'ROU',
  ru: 'RUS',
  'gb-sct': 'SCO',
  rs: 'SRB',
  sk: 'SVK',
  si: 'SVN',
  es: 'ESP',
  se: 'SWE',
  ch: 'SUI',
  tr: 'TUR',
  ua: 'UKR',
  'gb-wls': 'WAL',

  // CONMEBOL
  ar: 'ARG',
  bo: 'BOL',
  br: 'BRA',
  cl: 'CHI',
  co: 'COL',
  ec: 'ECU',
  py: 'PAR',
  pe: 'PER',
  uy: 'URU',
  ve: 'VEN',

  // CONCACAF
  ca: 'CAN',
  cr: 'CRC',
  hn: 'HON',
  jm: 'JAM',
  mx: 'MEX',
  pa: 'PAN',
  us: 'USA',

  // CAF
  dz: 'ALG',
  cm: 'CMR',
  cd: 'COD',
  ci: 'CIV',
  eg: 'EGY',
  gh: 'GHA',
  ml: 'MLI',
  ma: 'MAR',
  ng: 'NGA',
  sn: 'SEN',
  za: 'RSA',
  tn: 'TUN',

  // AFC
  au: 'AUS',
  ir: 'IRN',
  jp: 'JPN',
  kr: 'KOR',
  sa: 'KSA',
  qa: 'QAT',
  uz: 'UZB',
  iq: 'IRQ',

  // OFC
  nz: 'NZL',
}
